import 'micromodal';

const defaultOptions = {
  // onShow: modal => console.info(`${modal.id} is shown`),
  // onClose: modal => console.info(`${modal.id} is hidden`),
  // openTrigger: 'data-custom-open',
  // closeTrigger: 'data-custom-close',
  // openClass: 'is-open',
  disableScroll: true,
  // disableFocus: false,
  awaitOpenAnimation: true,
  awaitCloseAnimation: true,
  // debugMode: true,
};

const initModal = () => {
  return MicroModal.init(defaultOptions);
};

export default initModal;
